import { useEffect, useState } from 'react';
import { fetchIsRetail } from 'purchase-motions-api/query/eligibility';
import { isRpcError } from '../utils/error';
import Raven from 'raven-js';
export const useIsRetail = () => {
  const [isRetail, setIsRetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchIsRetail().then(response => {
      setIsRetail(response);
    }).catch(e => {
      if (!isRpcError(e) || e.cause.status !== 0) {
        Raven.captureException(new Error('Failed at fetchIsRetail', {
          cause: e
        }));
        setIsRetail(false);
        setError(e);
      }
    }).finally(() => setLoading(false));
  }, []);
  return {
    error,
    loading,
    isRetail
  };
};